import MapHandlyDefinedInfo from "./model/MapHandlyDefinedInfo";

export enum MapInstance {
  CHERNARUS_PLUS = "chernarusplus",
}

